import client from '../../api';
import { appHcUsers } from '../../api/endpoints';

const {
    index,
} = appHcUsers;

export const lookupAppHcUserApi = params => client.get(index, { params });
